module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAVCAYAAAB/sn/zAAAAuklEQVQoke2RMQrCQBBFX0IKtRBSpfQYphNEXLDRQ4gpxdbCe+QGltqIuYAsCBZiaWGhvZ2CRWQhK0PCFjZW/mr+zGP+LuPleY5VnGQeoIAOEAFP4ArsAgE1gDXQo6qzL1pTB2R0CITploZ7YAnUgJMEoxI41qk6WiOjmyXwJo3XnmxXRd0H6mK2AV6m0Kkameih4wMDaXwHVJHZOCuaCyAUwBx4fN5oLxMn2QVoCTDUqbp/Hf0HfwkCby4UI/hV4HYGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/_fb.png
// module id = 311
// module chunks = 0